/**
 * explorerRankConfig.js — Phase 6 · the SINGLE source of Explorer Rank
 * tiers and thresholds. Do not hard-code thresholds anywhere else.
 *
 * Rank is scored on a 0–100 "performance points" scale derived from the
 * learner's last ten eligible timed runs (see explorerRank.js). Each
 * tier has a `min` points threshold. "New Explorer" is the entry tier
 * and is also the forced state until 10 eligible runs exist.
 */
export const RANK_TIERS = [
  { id: "new-explorer",    label: "New Explorer",    min: 0,  emoji: "🧭" },
  { id: "wanderer",        label: "Wanderer",        min: 40, emoji: "🚶" },
  { id: "pathfinder",      label: "Pathfinder",      min: 50, emoji: "🗺️" },
  { id: "navigator",       label: "Navigator",       min: 60, emoji: "🧭" },
  { id: "trailblazer",     label: "Trailblazer",     min: 68, emoji: "🔥" },
  { id: "cartographer",    label: "Cartographer",    min: 75, emoji: "📐" },
  { id: "voyager",         label: "Voyager",         min: 82, emoji: "⛵" },
  { id: "pioneer",         label: "Pioneer",         min: 88, emoji: "🌟" },
  { id: "master-explorer", label: "Master Explorer", min: 93, emoji: "🏔️" },
  { id: "grand-explorer",  label: "Grand Explorer",  min: 97, emoji: "🏆" },
];

// Minimum eligible timed runs before a real rank is calculated.
export const MIN_RUNS_FOR_RANK = 10;

// Speed model (ms/question). Used to convert average response time into
// a 0..1 speed factor. Faster than FAST_MS = full credit; slower than
// SLOW_MS = no speed credit. Speed is always multiplied by accuracy so a
// fast-but-wrong run can never out-score a slower accurate one.
export const SPEED_FAST_MS = 2500;
export const SPEED_SLOW_MS = 9000;

// Composite score weights (sum = 100).
export const RANK_WEIGHTS = {
  accuracy: 60,     // mean accuracy across last 10
  reliability: 15,  // share of runs at/above a solid accuracy bar
  speed: 15,        // speed-after-correct (× accuracy)
  consistency: 10,  // low variance in accuracy
};

// A run counts toward "reliability" when accuracy is at/above this bar.
export const RELIABILITY_BAR = 0.8;
